module.exports = __webpack_public_path__ + "media/images/icons/v2/globe-05-6d4f3386721207c078d83d1e859eb539.svg";